import React from "react";
import DownloadRedirect from "../components/DownloadRedirect";
import {
  BUSINESS_ANDROID_STORE_URL,
  getDeviceType,
  getPartnerSignInUrl
} from "../utils/appLinks";

// Keep the early redirect in public/index.html in sync with these destinations.
function DownloadBusiness({ openUrl }) {
  const destination = getDeviceType() === "android"
    ? BUSINESS_ANDROID_STORE_URL
    : getPartnerSignInUrl();

  return (
    <DownloadRedirect
      destination={destination}
      appName="Mondoway Business"
      openUrl={openUrl}
    />
  );
}

export default DownloadBusiness;
